var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"data-test-id":"LogoutComponent"}},[_c('div',{staticClass:"text-red",attrs:{"data-test-id":"logoutButton","role":"button","tabindex":"0"},on:{"click":_vm.onLogoutClick}},[_vm._v("Logout")])])
}
var staticRenderFns = []

export { render, staticRenderFns }